<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="IMEI" v-model="imei" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
    >
      <el-table-column prop="device_id" label="设备编号" >
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" > </el-table-column>
      <el-table-column prop="timestamp" label="系统时间" >
      </el-table-column>
      <el-table-column prop="timezone" label="ECU时区" >
      </el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleClick(scope.row)">
            下发
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      data: [],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
    async created() {
    if (this.$route.params.id) {
      this.deviceId = this.$route.params.id !== ':id' ? this.$route.params.id : '';
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    handleClick(row) {
      // 处理点击事件，例如发送请求
      console.log('点击了下发按钮', row);
      const params = {
        deviceId: row.device_id,
        imei: row.imei,
        commandType: 'SYNC',
        timezone:480
      };
      this.$http
        .post(`${this.env}/manage/serviceTopicDataDownload/downTopic`, params)
        .then((results) => {
          console.log(results);
          if (results["data"]["code"] === 200) {
            this.$message({
              message: "下发成功",
              type: "success",
            });
          } else {
            this.$message({
              message: results["data"]["msg"],
              type: "error",
            });
          }
        });
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        topicType: "S/SYNC",
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      this.$http
        .post(`${this.env}/manage/serviceTopicDataDownload/list`, params)
        .then((results) => {
          const records = results["data"]["data"]["records"];
          // 解析 json_data 字段
          this.data = records.map(item => {
            let jsonData = {};
            try {
              jsonData = JSON.parse(item.json_data || '{}');
            } catch (e) {
              console.error('解析 json_data 失败:', e);
            }
            // 从 data 中提取系统时间和ECU时区
            const syncData = jsonData.data || {};
            return {
              ...item,
              syncId: jsonData.syncId || '',
              syncType: jsonData.syncType || '',
              timestamp: syncData.timestamp,
              timezone: syncData.timezone || '',
              description: jsonData.description || '',
              cmdData: item.cmd_data || '',
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },

  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>